/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { VolumeSettings } from '../models/VolumeSettings';

export class InventorySnapshotVolume {
  /**
  * Cloud-provider-assigned volume ID.
  */
  'providerVolumeId': string;
  /**
  * Region the volume is hosted in.
  */
  'region': string;
  /**
  * Availability zone the volume is hosted in.
  */
  'availabilityZone': string;
  /**
  * Volume tags as key-value pairs. Both keys and values are strings.  **Example**: `{\"env\": \"prod\", \"db\": \"\"}` 
  */
  'tags': { [key: string]: string; };
  /**
  * The allocated size of the volume in bytes
  */
  'allocatedSize'?: number;
  'volumeSettings': VolumeSettings;
  /**
  * Display name of the volume
  */
  'volumeLabel'?: string;
  /**
  * The device name the volume is attached to
  */
  'deviceName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providerVolumeId",
      "baseName": "providerVolumeId",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "availabilityZone",
      "baseName": "availabilityZone",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "allocatedSize",
      "baseName": "allocatedSize",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "volumeSettings",
      "baseName": "volumeSettings",
      "type": "VolumeSettings",
      "format": ""
    },
    {
      "name": "volumeLabel",
      "baseName": "volumeLabel",
      "type": "string",
      "format": ""
    },
    {
      "name": "deviceName",
      "baseName": "deviceName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return InventorySnapshotVolume.attributeTypeMap;
  }

  public constructor() {
  }
}

